// extracted by mini-css-extract-plugin
module.exports = {"dashboardHeadingSkeleton":"DashboardHeadingSkeleton_dashboardHeadingSkeleton__26CgH"};